import { NgModule } from '@angular/core';
import { currentUserResolverInjectionToken } from "./session/current-user-resolver-injection-token";
import { CurrentUserResolver } from "./session/current-user.resolver";
import { appResolverInjectionToken } from "./application/app/app-resolver-injection-token";
import { AppResolver } from "./application/app/app.resolver";
import { appPageResolverInjectionToken } from "./application/app/app-page-resolver-injection-token";
import { AppPageResolver } from "./application/app/app-page.resolver";
import {
  appVersionPageResolverInjectionToken
} from './application-version/app-version/app-version-page-resolver-injection-token';
import { AppVersionPageResolver } from "./application-version/app-version/app-version-page.resolver";
import { launcherPageResolverInjectionToken } from "./application/launcher/launcher-page-resolver-injection-token";
import { LauncherPageResolver } from "./application/launcher/launcher-page.resolver";
import { launcherResolverInjectionToken } from "./application/launcher/launcher-resolver-injection-token";
import { LauncherResolver } from "./application/launcher/launcher.resolver";
import { widgetPageResolverInjectionToken } from "./application/widget/widget-page-resolver-injection-token";
import { WidgetPageResolver } from "./application/widget/widget-page.resolver";
import { widgetResolverInjectionToken } from "./application/widget/widget-resolver-injection-token";
import { WidgetResolver } from "./application/widget/widget.resolver";
import {
  launcherVersionPageResolverInjectionToken
} from "./application-version/launcher-version/launcher-version-page-resolver-injection-token";
import {
  LauncherVersionPageResolver
} from "./application-version/launcher-version/launcher-version-page.resolver";
import {
  widgetVersionPageResolverInjectionToken
} from "./application-version/widget-version/widget-version-page-resolver-injection-token";
import {
  WidgetVersionPageResolver
} from "./application-version/widget-version/widget-version-page.resolver";

@NgModule( {
  providers: [
    {
      provide: currentUserResolverInjectionToken,
      useClass: CurrentUserResolver
    }, {
      provide: appResolverInjectionToken,
      useClass: AppResolver
    }, {
      provide: appPageResolverInjectionToken,
      useClass: AppPageResolver
    }, {
      provide: appVersionPageResolverInjectionToken,
      useClass: AppVersionPageResolver
    }, {
      provide: launcherPageResolverInjectionToken,
      useClass: LauncherPageResolver
    }, {
      provide: launcherResolverInjectionToken,
      useClass: LauncherResolver
    }, {
      provide: widgetPageResolverInjectionToken,
      useClass: WidgetPageResolver
    }, {
      provide: widgetResolverInjectionToken,
      useClass: WidgetResolver
    }, {
      provide: launcherVersionPageResolverInjectionToken,
      useClass: LauncherVersionPageResolver
    }, {
      provide: widgetVersionPageResolverInjectionToken,
      useClass: WidgetVersionPageResolver
    }
  ]
} )
export class ResolversModule {
}
